var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"js6gCfEtaGBhmMR9OeHaf"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["gsu-web@getsetup-inc"]={id:"js6gCfEtaGBhmMR9OeHaf"};
      